import React, { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { Users, Star, TrendingUp, Download, Filter } from 'lucide-react';
import { PageHeader } from '../../components/layout';
import { Card, CardBody, Button, Select, DatePicker, Table, Badge } from '../../components/common';
import { reportApi } from '../../services/api';
import './Reports.css';

export default function VendorPerformanceReport() {
    const [dateFrom, setDateFrom] = useState('');
    const [dateTo, setDateTo] = useState('');

    const { data, isLoading, refetch } = useQuery({
        queryKey: ['reports', 'vendor-performance', dateFrom, dateTo],
        queryFn: () => reportApi.getVendorPerformance({ dateFrom, dateTo }),
        select: (res) => res.data?.data || []
    });

    const getRatingStars = (rating) => {
        const stars = [];
        for (let i = 1; i <= 5; i++) {
            stars.push(
                <Star
                    key={i}
                    size={14}
                    fill={i <= rating ? '#fbbf24' : 'none'}
                    color={i <= rating ? '#fbbf24' : '#d1d5db'}
                />
            );
        }
        return <div className="rating-stars">{stars}</div>;
    };

    const columns = [
        { key: 'vendor', title: 'Vendor', render: (_, row) => row.vendor?.name },
        { key: 'totalOrders', title: 'Total Orders', dataIndex: 'totalOrders', align: 'center' },
        {
            key: 'onTimeDelivery', title: 'On-Time %', dataIndex: 'onTimeDeliveryRate', align: 'center',
            render: (val) => <Badge variant={val >= 90 ? 'success' : val >= 70 ? 'warning' : 'danger'}>{val}%</Badge>
        },
        {
            key: 'qualityScore', title: 'Quality', dataIndex: 'qualityScore', align: 'center',
            render: (val) => getRatingStars(val)
        },
        {
            key: 'avgResponseTime', title: 'Avg Response', dataIndex: 'avgResponseTime',
            render: (val) => `${val} days`
        },
        {
            key: 'overallRating', title: 'Overall', dataIndex: 'overallRating', align: 'center',
            render: (val) => <span className="overall-rating">{val?.toFixed(1)}</span>
        }
    ];

    return (
        <div className="report-page">
            <PageHeader
                title="Vendor Performance Report"
                subtitle="Analyze vendor performance metrics"
                breadcrumbs={[
                    { label: 'Reports', path: '/reports' },
                    { label: 'Vendor Performance' }
                ]}
                actions={
                    <Button icon={Download}>Export</Button>
                }
            />

            <Card>
                <CardBody>
                    <div className="report-filters">
                        <DatePicker label="From" value={dateFrom} onChange={setDateFrom} />
                        <DatePicker label="To" value={dateTo} onChange={setDateTo} />
                        <Button icon={Filter} onClick={() => refetch()}>Apply Filter</Button>
                    </div>
                </CardBody>
            </Card>

            <Card>
                <Table
                    columns={columns}
                    data={data || []}
                    loading={isLoading}
                    emptyText="No vendor data found"
                    rowKey="id"
                />
            </Card>
        </div>
    );
}
